export default __webpack_public_path__ + "static/media/GoodMannersInARestaurant_08.8637543a.png";